export default "__VITE_ASSET__Ce7LrJx9__"